import { render, staticRenderFns } from "./RestPassWord.vue?vue&type=template&id=438a6d1a&scoped=true&"
import script from "./RestPassWord.vue?vue&type=script&lang=js&"
export * from "./RestPassWord.vue?vue&type=script&lang=js&"
import style0 from "./RestPassWord.vue?vue&type=style&index=0&id=438a6d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438a6d1a",
  null
  
)

export default component.exports